import messageModule from "@/store/modules/message-module";
import CargandoModule from "@/store/modules/cargando-module";

export default class ServiceMessage {
    public TypeSuccess = "success";
    public TypeError = "error";
    public TypeWarning = "warning";
    public TypeInfo = "info";
    public TypeQuestion: any = "question";

    public PositionTop = "top";
    public PositionTopStart = "top-start";
    public PositionTopEnd = "top-end";
    public PositionCenter = "center";
    public PositionCenterStart = "center-start";
    public PositionCenterEnd = "center-end";
    public PositionBottom = "bottom";
    public PositionBottomStart = "bottom-start";
    public PositionBottomEnd = "bottom-end";

    private defaultTimeout = 3000;
    private customClass = "";

    public setCustomClass(customClass: string) {
        this.customClass = customClass;
    }

    // Aviso flotante que se apila (Stacked Toast)
    public toast(
        texto: string,
        tipo: any = this.TypeSuccess,
        timeout: number = this.defaultTimeout,
        posicion: any = this.PositionTop,
        customClass: any = this.customClass
    ) {
        return messageModule.showToast({ text: texto, type: tipo, timeout });
    }

    public toastsuccesful(texto: string) {
        this.toast(texto, this.TypeSuccess);
    }

    public toastinfo(texto: string) {
        return this.toast(texto, this.TypeWarning, 100000);
    }

    public alert(
        titulo: string,
        texto: string = "",
        tipo: any = this.TypeSuccess,
        timeout: number = this.defaultTimeout,
        posicion: any = this.PositionCenter,
        customClass: any = this.customClass
    ) {
        messageModule.showAlert({ title: titulo, text: texto, type: tipo });
    }

    public alertRespose(
        titulo: string,
        texto: string = "",
        cb: (res: boolean) => void,
        tipo: any = this.TypeSuccess,
        timeout: number = this.defaultTimeout,
        posicion: any = this.PositionCenter,
        customClass: any = this.customClass
    ) {
        // Para alertas simples con callback lo manejamos como confirmación pero simplificada
        messageModule.showConfirm({ title: titulo, text: texto, cb });
    }

    public confirm(
        texto: string,
        titulo = "Pregunta",
        cb: (res: boolean) => void,
        customClass: any = this.customClass
    ) {
        messageModule.showConfirm({ title: titulo, text: texto, cb });
    }

    public showLoading(customClass: any = this.customClass) {
        CargandoModule.ShowEspera();
    }

    public hideLoading() {
        CargandoModule.CloseEspera();
    }
}

export const MessageService = new ServiceMessage();
